export default __webpack_public_path__ + "static/media/icon-close.bbbbb006.svg";